export var EReportingFrequencyType;
(function (EReportingFrequencyType) {
    EReportingFrequencyType["Daily"] = "DAILY";
    EReportingFrequencyType["Weekly"] = "WEEKLY";
    EReportingFrequencyType["Monthly"] = "MONTHLY";
    EReportingFrequencyType["Quarterly"] = "QUARTERLY";
    EReportingFrequencyType["BiYearly"] = "BI_YEARLY";
    EReportingFrequencyType["Yearly"] = "YEARLY";
})(EReportingFrequencyType || (EReportingFrequencyType = {}));
